module.exports = __webpack_public_path__ + "static/media/Gas.d831af68.svg";